// extracted by mini-css-extract-plugin
export default {"container":"Cj8UCb","header":"U_SJsn"};